<template>
  <div class="w-full px-5" v-if="form">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="General Details" name="general">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="user_id">
              <label class="text-sm block">Customer:</label>
              <el-select class="w-full" v-model="form.user_id" filterable placeholder="Please select...">
                <el-option
                  v-for="cus in customers"
                  :key="cus.id"
                  :label="cus.email"
                  :value="cus.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="status_id">
              <label class="text-sm block">Order status:</label>
              <el-select class="w-full" v-model="form.status_id" filterable placeholder="Please select...">
                <el-option
                  v-for="status in statuses"
                  :key="status.id"
                  :label="status.name"
                  :value="status.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="outlet_id">
              <label class="text-sm block">Processing outlet:</label>
              <el-select class="w-full" v-model="form.outlet_id" filterable placeholder="Please select...">
                <el-option
                  v-for="outlet in outlets"
                  :key="outlet.id"
                  :label="outlet.name"
                  :value="outlet.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="pickup_outlet_id">
              <label class="text-sm block">Pickup outlet:</label>
              <el-select class="w-full" v-model="form.pickup_outlet_id" filterable placeholder="Please select...">
                <el-option
                  v-for="outlet in outlets"
                  :key="outlet.id"
                  :label="outlet.name"
                  :value="outlet.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_method_id">
              <label class="text-sm block">Delivery method:</label>
              <el-select class="w-full" v-model="form.delivery_method_id" filterable placeholder="Please select...">
                <el-option
                  v-for="outlet in delivery_methods"
                  :key="outlet.id"
                  :label="outlet.name"
                  :value="outlet.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="est_delivery_time">
              <label class="text-sm block">Est. delivery time</label>
              <el-date-picker
                class="w-full"
                v-model="form.est_delivery_time"
                type="datetime"
                placeholder="Select date and time">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24">
            <el-form-item prop="admin_comments">
              <label class="text-sm block">Admin comment:</label>
              <el-input type="textarea" :rows="2" class="w-full"
                        v-model="form.admin_comments"
                        placeholder="Enter your comment here">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Delivery Address" name="shipping">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_first_name">
              <label class="text-sm block">First name</label>
              <el-input class="w-full" type="text"
                        v-if="form.deliveryAddress"
                        v-model="form.deliveryAddress.first_name">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_last_name">
              <label class="text-sm block">Last name</label>
              <el-input class="w-full" type="text"
                        v-if="form.deliveryAddress"
                        v-model="form.deliveryAddress.last_name">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_phone">
              <label class="text-sm block">Phone</label>
              <el-input class="w-full" type="text"
                        v-if="form.deliveryAddress"
                        v-model="form.deliveryAddress.phone">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_address">
              <label class="text-sm block">Address</label>
              <el-input class="w-full" type="text"
                        v-if="form.deliveryAddress"
                        v-model="form.deliveryAddress.address">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_phone">
              <label class="text-sm block">Zip/Postal Code</label>
              <el-input class="w-full" type="number"
                        v-if="form.deliveryAddress"
                        v-model="form.deliveryAddress.zip_code">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_city">
              <label class="text-sm block">City</label>
              <el-input class="w-full" type="text"
                        v-if="form.deliveryAddress"
                        v-model="form.deliveryAddress.city">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_state">
              <label class="text-sm block">State</label>
              <el-input class="w-full" type="text"
                        v-if="form.deliveryAddress"
                        v-model="form.deliveryAddress.state">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_country">
              <label class="text-sm block">Country</label>
              <el-input class="w-full" type="text"
                        v-if="form.deliveryAddress"
                        v-model="form.deliveryAddress.country">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Billing Address" name="billing">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_first_name">
              <label class="text-sm block">First name</label>
              <el-input class="w-full" type="text"
                        v-if="form.billingAddress"
                        v-model="form.billingAddress.first_name">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_last_name">
              <label class="text-sm block">Last name</label>
              <el-input class="w-full" type="text"
                        v-if="form.billingAddress"
                        v-model="form.billingAddress.last_name">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_phone">
              <label class="text-sm block">Phone</label>
              <el-input class="w-full" type="text"
                        v-if="form.billingAddress"
                        v-model="form.billingAddress.phone">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_address">
              <label class="text-sm block">Address</label>
              <el-input class="w-full" type="text"
                        v-if="form.billingAddress"
                        v-model="form.billingAddress.address">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_phone">
              <label class="text-sm block">Zip/Postal Code</label>
              <el-input class="w-full" type="number"
                        v-if="form.billingAddress"
                        v-model="form.billingAddress.zip_code">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_city">
              <label class="text-sm block">City</label>
              <el-input class="w-full" type="text"
                        v-if="form.billingAddress"
                        v-model="form.billingAddress.city">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_state">
              <label class="text-sm block">State</label>
              <el-input class="w-full" type="text"
                        v-if="form.billingAddress"
                        v-model="form.billingAddress.state">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="delivery_country">
              <label class="text-sm block">Country</label>
              <el-input class="w-full" type="text"
                        v-if="form.billingAddress"
                        v-model="form.billingAddress.country">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Ordered Items" name="items">
        <el-row class="items col-hd py-2">
          <el-col :span="12" class="pt-2 pb-2 px-2">Item</el-col>
          <el-col :span="4" class="pt-2 pb-2 px-2">Qty</el-col>
          <el-col :span="4" class="pt-2 pb-2 px-2">Unit Price</el-col>
          <el-col :span="4" class="pt-2 pb-2 px-2">
            <el-button
              size="mini"
              type="info"
              icon="el-icon-plus-outline" @click="$modal.show('new-ordered-item-modal')">Add Item</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="items px-2 py-2" v-for="oItem of form.orderedItems">
          <el-col :span="12" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-select v-model="selectedItemId" filterable size="mini">
                  <el-option
                    v-for="item of items"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </span>
            <span v-else>{{oItem.item_name}}</span>
          </el-col>
          <el-col :span="4" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-input v-model="selectedItemQty" type="number" size="mini"></el-input>
              </span>
            <span v-else>{{ oItem.quantity }}</span>
          </el-col>
          <el-col :span="4" class="col-item">
            {{ Number(oItem.item_price).toFixed(2) }}
          </el-col>
          <el-col :span="4" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-button @click="updateItem(oItem.id)" size="mini" icon="el-icon-success"
                           type="text" class="text-green-500">Update</el-button>
                <el-button size="mini" icon="el-icon-error" type="text" class="text-red-500"
                           @click="closeEdit()">Cancel</el-button>
              </span>
            <span v-else>
                <el-button @click="editItem(oItem.id, oItem, oItem.quantity)" type="text"
                           icon="el-icon-edit-outline" size="mini">Edit</el-button>
                <el-button @click="deleteItem(oItem.id)" type="text" icon="el-icon-delete-solid"
                           size="mini" class="text-red-500">Remove</el-button>
              </span>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <NewOrderItemForm :order="form" />
  </div>
</template>

<script>
import NewOrderItemForm from './NewOrderItemForm.vue';

export default {
  name: 'OrderForm',
  components: {
    NewOrderItemForm,
  },
  props: ['form'],
  data() {
    return {
      activeName: 'general',
      updating: false,
      editMode: false,
      orderedItemInEditMode: '',
      selectedItemId: '',
      selectedItemQty: '',
      date_format: 'YYYY-MM-DD HH:mm',
      est_date: '2019-10-09',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    notBeforeToday(date) {
      return date < today;
    },
    editItem(orderedItem, item, qty) {
      this.editMode = true;
      this.orderedItemInEditMode = orderedItem;
      this.selectedItemId = item.item_id;
      this.selectedItemQty = qty;
    },
    async updateItem(id) {
      const item = this.items.filter(el => el.id === this.selectedItemId)[0];
      const formData = {
        item_id: this.selectedItemId,
        quantity: this.selectedItemQty,
        item_name: item.name,
        item_price: item.price,
        item_weight: item.weight,
        item_preview: item.image,
      };
      try {
        this.updating = true;
        await this.$store.dispatch('OrderModule/updateOrderItem',
          { orderedItemId: id, orderedItem: formData });
        this.$notify.success({
          title: 'Success',
          message: 'Order update was successful.',
        });
        this.closeEdit();
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.updating = false;
    },
    closeEdit() {
      this.editMode = false;
      this.orderedItemInEditMode = '';
      this.selectedItemId = '';
      this.selectedItemQty = '';
    },
    deleteItem(id) {
      this.$confirm('Are you sure you want to delete this order item?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('OrderModule/deleteOrderItem', { orderId: id });
          this.$notify.success({
            title: 'Success',
            message: 'Order item has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
  computed: {
    customers() {
      return this.$store.state.CustomerModule.customers;
    },
    outlets() {
      return this.$store.state.OutletModule.outlets;
    },
    statuses() {
      return this.$store.state.SettingsModule.Statuses.statuses;
    },
    delivery_methods() {
      return this.$store.state.SettingsModule.DeliveryMethods.delivery_methods;
    },
    items() {
      return this.$store.state.InventoryModule.Products.products;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('CustomerModule/fetchAllCustomers', { page: null, limit: null });
      await this.$store.dispatch('SettingsModule/Statuses/fetchAllStatuses');
      await this.$store.dispatch('OutletModule/fetchAllOutlets');
      await this.$store.dispatch('SettingsModule/DeliveryMethods/fetchAllDeliveryMethods', { page: null, limit: null });
      await this.$store.dispatch('InventoryModule/Products/fetchPluckedProducts');
    } catch (e) {
      console.log(e)
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped lang="scss">
.w-full {
  width: 100% !important;
  .mx-input { height: 40px !important; }
}
.col-hd {
  font-size: 15px;
  font-weight: 500;
  margin-top: 10px;
  background-color: #f9f9f9;
}
.items {
  color: #909399;
  .col-item {
    padding-bottom: 6px;
  }
}
</style>
